<% var component = new Anvil.models.components.Grid(name, list, params) %>
<div anvil-component="<%- component.id %>" id="<%- component.name %>_grid" class="grid-wrapper" style="white-space:nowrap;<% if ('height' in params) { %> height:<%- params.height %>;<% } %>">

	<% if (params.map) { %>
	<div class="grid-map" style="position:relative; overflow-y:auto; height:calc(100vh - 155px);">
		<div id="<%- component.id %>_map_frame" style="position:relative; width:100%; height:calc(100% - 85px); z-index:0;"></div>
		<table class="table table-sm grid-table">
			<tfoot>
				<tr>
					<td>
						<i class="fa fa-map me-1"></i> <span class="map-display-total"></span>
						<i class="fa fa-map-marker-alt ms-3 me-1"></i> <span class="map-display-view"></span>
						<div class="form-check form-switch d-inline ms-3">
							<label><input type="checkbox" class="form-check-input map-display-collapse-markers"/> Közeli helyek csoportosítása</label>
						</div>
						<div class="grid-extra-footer d-none d-lg-block float-end text-right"></div>
					</td>
				</tr>
			</tfoot>
		</table>
	</div>
	<% } %>

	<div class="grid-list">
		<table class="table table-sm grid-table position-relative">
			<thead>
				<tr>
					<% for (let i = 0; i < component.columns.length; i++) { %>
					<th scope="col" field="<%- i %>" <% if ('width' in component.columns[i]) { %>style="min-width:<%- component.columns[i].width %>px; width:<%- component.columns[i].width %>px;"<% } %>>
						<div class="row g-0 flex-nowrap">
							<div class="col me-2"><%- component.columns[i].title %></div>
							<div class="col-auto text-right"><% if (component.columns[i].sort) { %><span class="sort"><span class="badge bg-primary rounded-pill me-1">0</span><i class="fa fa-sort"></i></span><% } %></div>
						</div>
					</th>
					<% } %>
					<th style="width:100%"></th>
				</tr>
			</thead>
		</table>
		<div class="grid-content">
			<table class="table table-sm grid-table">
				<tbody>
				</tbody>
			</table>
		</div>
		<table class="table table-sm grid-table">
			<tfoot>
				<tr>
					<td colspan="<%= component.columns.length + 1 %>">
						<i class="fa fa-list me-1"></i> <span class="table-display-total"></span>
						<i class="fa fa-eye ms-3 me-1"></i> <span class="table-display-view"></span>
						<i class="fa fa-mouse-pointer ms-3 me-1"></i> <span class="table-display-selection">0</span>
						<div class="grid-extra-footer d-none d-lg-block float-end text-right"></div>
					</td>
				</tr>
			</tfoot>
		</table>
	</div>
</div>